import React from 'react';
import {
  Card,
  Table
} from 'semantic-ui-react';
import moment from 'moment';
import { ReadyState, useSocket } from '../hooks/useSocket';

const CurrentlyLive = () => {
  const { users, state } = useSocket();

  return (
    <Table celled compact definition inverted>
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell>
            Currently Live:
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            {!users.length || state !== ReadyState.OPEN ? (
              <p>
                <br /><br />
                <center><h2>{state !== ReadyState.OPEN ? `Disconnected... trying to reconnect...` : `No one currently streaming!`}</h2></center>
                <br /><br />
              </p>
            ) : (
              <Card.Group itemsPerRow={4} stackable>
                {users.map((streamer, index) =>
                  <Card
                    href={`https://www.twitch.tv/${streamer.channel}`}
                    image={streamer.profile_image_url}
                    header={streamer.display_name}
                    meta={`Online since: ${moment.unix(streamer.login_time).fromNow()}`}
                    className='streamer'
                  />
                )}
              </Card.Group>
            )}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  )
};

export default CurrentlyLive;
